import { useState, useEffect } from "react";

function RSVPListByGuest() {
    const [guests, setGuests] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [loadingError, setLoadingError] = useState(false);

    // ✅ FILTER STATE (tri-state: "", "true", "false")
    const [attendWedding, setAttendWedding] = useState("true"); // default YES
    const [attendWelcomeParty, setAttendWelcomeParty] = useState(""); // default ALL

    useEffect(() => {
        fetchData();
    }, [attendWedding, attendWelcomeParty]);

    async function fetchData() {
        setPageLoading(true);
        setLoadingError(false);

        try {
            const params = new URLSearchParams();

            if (attendWedding !== "") {
                params.append("attend_wedding", attendWedding);
            }

            if (attendWelcomeParty !== "") {
                params.append("attend_welcome_party", attendWelcomeParty);
            }

            const url = `https://wedding-website-backend-nu.vercel.app/api/guests${params.toString() ? `?${params.toString()}` : ""
                }`;

            const res = await fetch(url);

            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }

            const data = await res.json();
            setGuests(data.guests);
        } catch (err) {
            console.error(err);
            setLoadingError(true);
        } finally {
            setPageLoading(false);
        }
    }

    const renderResponse = (bool) => {
        if (bool === true) return "Yes";
        if (bool === false) return "No";
        return "";
    };

    return (
        <div className="text-center rounded border p-2">
            {/* ✅ LIVE COUNT */}
            <div className="subheading text-bronze mb-4 text-2xl">
                Guests ({guests.length})
            </div>

            {/* ✅ FILTERS */}
            <div className="flex gap-4 justify-center mb-4 text-sm">
                <div>
                    <label className="block mb-1">Wedding</label>
                    <select
                        value={attendWedding}
                        onChange={(e) => setAttendWedding(e.target.value)}
                        className="border p-1"
                    >
                        <option value="">All</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </div>

                <div>
                    <label className="block mb-1">Welcome Party</label>
                    <select
                        value={attendWelcomeParty}
                        onChange={(e) => setAttendWelcomeParty(e.target.value)}
                        className="border p-1"
                    >
                        <option value="">All</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </div>
            </div>

            {/* STATES */}
            {pageLoading && <p>Loading...</p>}
            {loadingError && (
                <p className="text-red-400">Failed to fetch guests</p>
            )}

            {/* TABLE */}
            {!pageLoading && !loadingError && (
                <div className="space-y-2">
                    <ul>
                        <li className="border px-2 bg-bronze text-white">
                            <div className="flex items-center w-full p-1">
                                <div className="flex-1">
                                    <div className="flex text-xs py-1 w-full">
                                        <div className="flex-[2_2_0%] px-1">Guest Name</div>
                                        <div className="flex-1 px-1">Attending Wedding?</div>
                                        <div className="flex-1 px-1">Attending Welcome Party?</div>
                                        <div className="flex-1 px-1">Entree</div>
                                        <div className="flex-1 px-1">Age Group</div>
                                        <div className="flex-[3_3_0%] px-1">
                                            Dietary Restrictions
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>

                    <ul className="scroll-box space-y-2 max-h-96 overflow-y-auto">
                        {guests.map((guest) => (
                            <li key={guest.id + guest.name} className="border p-2">
                                <div className="flex text-xs w-full">
                                    <div className="flex-[2_2_0%] px-1">
                                        {guest.name}
                                    </div>
                                    <div className="flex-1 px-1">
                                        {renderResponse(guest.attend_wedding)}
                                    </div>
                                    <div className="flex-1 px-1">
                                        {renderResponse(guest.attend_welcome_party)}
                                    </div>
                                    <div className="flex-1 px-1">
                                        {guest.wedding_entree}
                                    </div>
                                    <div className="flex-1 px-1">
                                        {guest.age_group}
                                    </div>
                                    <div className="flex-[3_3_0%] px-1 whitespace-nowrap overflow-hidden text-ellipsis">
                                        {guest.dietary_restrictions}
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}

export default RSVPListByGuest;